import { createSlice } from '@reduxjs/toolkit';

import {
  RootState,
  fetchOrderInfo,
} from '../../store';

// Slice with all needed to show Cover
export const coverSlice = createSlice({
  name: 'cover',
  initialState: {
    orderPermalink: '',
    mapId: 0,
    vrId: 0,
    splashImage: '',
    bgImage: '',
    bgColor: '',
    title: '',
    subtitle: '',
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrderInfo.fulfilled, (state, { payload }) => {
      state.orderPermalink = payload.permalink;
      state.mapId = payload.mapId;
      state.vrId = payload.vrId;
      state.splashImage = payload.splashImage;
      state.bgImage = payload.coverImage;
      state.title = payload.description;
      state.subtitle = payload.subtitle;
    });
  },
});

export const coverSelector = (state: RootState) => state.cover;
